module.exports = __webpack_public_path__ + "img/kejian.4355da46.png";